export default "__VITE_ASSET__CMiG90tK__"